<template>
  <div
    class="container"
    :class="{ lightBackground: !isDarkMode, darkBackground: isDarkMode }"
  >
    <vue-title title="WOLF | Recover password" />
    <div class="login">
      <img src="@/assets/wolf-darkMode.svg" alt="Logo" v-show="isDarkMode" />
      <img src="@/assets/wolf-lightMode.svg" alt="Logo" v-show="!isDarkMode" />
      <h4 :class="{ lightText: isDarkMode, darkText: !isDarkMode }">
        Recover your password
      </h4>
      <form @submit.prevent="onSubmit">
        <input
          type="email"
          placeholder="Email"
          autocomplete="on"
          :class="{
            lightField: isDarkMode,
            darkField: !isDarkMode,
            lightInput: isDarkMode,
            darkInput: !isDarkMode
          }"
          v-model="email"
          required
        />
        <button>Send email</button>
      </form>
      <router-link
        to="/signin"
        :class="{ lightLink: isDarkMode, darkLink: !isDarkMode }"
        >Already have an account? Sign in now</router-link
      >
      <ThemeSwitch />
    </div>
  </div>
</template>

<script>
import ThemeSwitch from "@/components/ThemeSwitch";
import VueTitle from "@/components/VueTitle";

import { auth } from "@/main";

export default {
  name: "Recover",
  components: {
    ThemeSwitch,
    VueTitle
  },
  data() {
    return {
      email: null,
      hasText: false,
      text: ""
    };
  },
  computed: {
    isDarkMode() {
      return this.$store.getters.isDarkMode;
    }
  },
  methods: {
    onSubmit() {
      const email = this.email;
      auth
        .requestPasswordRecovery(email)
        .then(() => {
          this.$router.push({
            name: "signin",
            params: {
              userRecoveredAccount: true,
              email: email
            }
          });
        })
        .catch(error => {
          alert("Error: " + error);
        });
    }
  },
  mounted() {
    const params = this.$route.params;
    if (params.userLoggedOut) {
      this.hasText = true;
      this.text = "You have logged out";
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: top;
  min-height: 100vh;
  padding-bottom: 24px;
  padding-top: 120px;
}
.login {
  width: 400px;
  text-align: center;
  margin-left: 16px;
  margin-right: 16px;
}

img {
  width: 150px;
  padding-bottom: 50px;
}
</style>
